export default "__VITE_ASSET__C71YZy$S__"